import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";
import { IEditTaskData } from "../types/edit-task-interface";

export const fetchEditTask = createAsyncThunk(
    'contract/fetchEditTask',
    async ({ formData, saveAsDraft, deletedFileIds, TaskID }: {
        formData: IEditTaskData,
        saveAsDraft: boolean,
        deletedFileIds: string[],
        TaskID: string
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "TaskID": TaskID,
                "ThemeID": formData.Themes,
                "AuthorsComment": formData.Comment,
                "AuthorsExpectedCompletionDate": formData.Date,
                "SaveAsDraft": saveAsDraft,
                "FilesToAdd": formData.FilesAdd,
                "FilesToDelete": deletedFileIds
            };
            const response = await getRequest(requestBody, 'dms-hr', 'getEditTask', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { taskID: data.Task.ID, taskNumber: data.Task.Number };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);